<template src="./home.html">

</template>

<script>
import EventiRecenti from '@/components/riepilogo/EventiRecenti.vue';
import ComunicazioniRecenti from '@/components/riepilogo/ComunicazioniRecenti.vue';

export default {

  components: {
    EventiRecenti,
    ComunicazioniRecenti
  },

  data: () => ({
    aggiornaEventi: 0,
    aggiornaComunicazioni: 0
  }),

  methods: {
    async init() {
      let resUpdate = await this.$i2kFunctions.checkUpdate(
        this.$load.getUrlUpdate()
      );

      if (resUpdate) this.$toast.update("E' disponibile una nuova versione");
    },

    apriAttivita() {
      this.aggiornaEventi += 1;
      this.aggiornaComunicazioni += 1;
    },

  },

  mounted() {
    this.init();
  },
};
</script>
